import { DiceRoller } from 'rpg-dice-roller'
import skills from './SkillsInfo'
import websocket from './WebsocketConnection'

function rollDice(diceAmount, diceValue) {
  const roller = new DiceRoller()
  const roll = roller.roll(diceAmount + diceValue).total //"1d20"
  websocket.rollDice(roll)
  return roll
}

function rollParanormal(paranormalValue) {
  const roller = new DiceRoller()
  const roll = roller.roll("1d100").total //"1d20"
  const successText = paranormalValue >= roll ? "Sucesso" : "Fracasso"
  websocket.rollDice("E. Paranormal" + " - " + successText + " - " + roll)
  return [successText, roll]
}

function rollSkill(skillValue) {
  if(skillValue > 20 || skillValue <= 0)
  return ['Erro', 0]
  
  let find = false;
  let result;
  let index = 0;

  let valueBreakers = skills.skillsNumbers[skillValue];

  const roller = new DiceRoller()
  const roll = roller.roll("1d20")
  const diceResult = roll.total;
  let successText = "";

  while (!find) {
    if (index > 2) {
      find = true
    }

    if (diceResult >= valueBreakers[index]) {
      result = valueBreakers.indexOf(valueBreakers[index])
      // find = true
    }

    index++
  }
  switch (result) {
    case 0:
      successText = 'Normal'
      break;
    case 1:
      successText = 'Bom'
      break;
    case 2:
      successText = 'Extremo'
      break;
    default:
      if (diceResult === 1 && skillValue !== 20) {
        successText = 'Desastre'
        break
      }
      successText = 'Fracasso'
      break
  }
  websocket.rollDice(successText + " - " + diceResult)
  return [successText, diceResult]
}

export { rollDice, rollSkill, rollParanormal }